/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bo as Bo,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
} from "../../runtime/index.jsx";
export function Componente_kk_107_107({
  titulo: e,
  filas: t,
  nombre: n = (e) => e,
}) {
  let r = Math.max(1, ...t.map((e) => e.cantidad));
  return (
    <section
      className={Bo}
      children={[
        <h3 className={`mb-3 font-medium text-(--text-h)`} children={e} />,
        t.length ? (
          <ul
            className={`max-h-72 space-y-2 overflow-y-auto`}
            children={t.map((e) => (
              <li
                key={e.nombre}
                className={`text-sm text-(--text)`}
                children={[
                  <div
                    className={`flex justify-between gap-2`}
                    children={[
                      <span children={n(e.nombre)} />,
                      <span children={e.cantidad} />,
                    ]}
                  />,
                  <div
                    className={`mt-1 h-1 rounded bg-(--accent-bg)`}
                    children={
                      <div
                        className={`h-full rounded bg-(--accent)`}
                        style={{
                          width: `${(e.cantidad * 100) / r}%`,
                        }}
                      />
                    }
                  />,
                ]}
              />
            ))}
          />
        ) : (
          <p
            className={`text-sm text-(--text)`}
            children={`Sin actividad registrada.`}
          />
        ),
      ]}
    />
  );
}
